// import React, { useEffect, useRef } from "react";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// import Placeholder from "../../assets/Images/ReportsDashboard.svg";

// gsap.registerPlugin(ScrollTrigger);

// export function TopFeatures() {
//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       ScrollTrigger.create({
//         trigger: ".topFeaturesContainer",
//         start: "top center",
//         end: "bottom bottom",
//         pin: ".imagesContainer", // pin the container, not the image
//         pinSpacing: true, // space below so content doesn't jump
//         anticipatePin: 1, // smooth pinning
//       });
//     });

//     return () => ctx.revert();
//   }, []);

//   return (
//     <section className="topFeaturesContainer">
//       <div className="descriptionContainer">
//         <div className="descriptionItem">
//           <h2 className="emphasisHeadline">Compliance Dashboard</h2>
//           <p className="bodyText">
//             Get a clear view of where your facility stands. Our dashboard makes
//             it easy to see which employees need training or competency
//             assessments.
//           </p>
//         </div>
//         <div className="descriptionItem">
//           <h2 className="emphasisHeadline">Drag-and-Drop Form Builder</h2>
//           <p className="bodyText">
//             Create the forms your facility needs — fast. Build custom forms for
//             inspections, emergency response plans, orientations, and more with
//             our intuitive drag-and-drop builder. Choose from yes/no, dropdowns,
//             text fields, and more.
//           </p>
//         </div>
//         <div className="descriptionItem">
//           <h2 className="emphasisHeadline">Inspections Made Easy</h2>
//           <p className="bodyText">
//             No paperwork. No delays. Whether it’s a near-miss or a major
//             incident, your team can report it right away using their phone or
//             tablet. Quick, easy, and always documented.
//           </p>
//         </div>
//       </div>
//       <div className="imagesContainer">
//         <img
//           src={Placeholder}
//           alt="Placeholder for Top Features"
//           className="topFeaturesImg"
//         />
//       </div>
//     </section>
//   );
// }

import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Placeholder from "../../assets/Images/ReportsDashboard.svg";

gsap.registerPlugin(ScrollTrigger);

export function TopFeatures() {
  ScrollTrigger.create({
    trigger: ".topFeaturesContainer",
    start: "top top",
    end: "bottom bottom",
    pin: ".imagesContainer", // pin the container, not the image
  });

  return (
    <section className="topFeaturesContainer">
      <div className="descriptionContainer">
        <div className="descriptionItem">
          <h2 className="emphasisHeadline">Compliance Dashboard</h2>
          <p className="bodyText">
            Get a clear view of where your facility stands. Our dashboard makes
            it easy to see which employees need training or competency
            assessments.
          </p>
        </div>
        <div className="descriptionItem">
          <h2 className="emphasisHeadline">Drag-and-Drop Form Builder</h2>
          <p className="bodyText">
            Create the forms your facility needs — fast. Build custom forms for
            inspections, emergency response plans, orientations, and more with
            our intuitive drag-and-drop builder. Choose from yes/no, dropdowns,
            text fields, and more.
          </p>
        </div>
        <div className="descriptionItem">
          <h2 className="emphasisHeadline">Inspections Made Easy</h2>
          <p className="bodyText">
            No paperwork. No delays. Whether it’s a near-miss or a major
            incident, your team can report it right away using their phone or
            tablet. Quick, easy, and always documented.
          </p>
        </div>
      </div>
      <div className="imagesContainer">
        <img
          src={Placeholder}
          alt="Placeholder for Top Features"
          className="topFeaturesImg"
        />
      </div>
    </section>
  );
}
